import { useTimelineContext } from '@/pages/PatientTimelinePage/hooks/useTimelineContext';
import { buildWarmHandoffPreview, hasAnyWarmHandoffAnswer } from '@bariendo/lib/patient-access-warm-handoff-note';
import { getReferenceString } from '@medplum/core';
import { Communication } from '@medplum/fhirtypes';
import { WarmHandoffTimelineGroup } from '../../types';
import { CallCardLabels, PatientAccessCallTimelineItem } from './PatientAccessCallTimelineItem';
import { WarmHandoffCard } from './WarmHandoffCard';

const LABELS: CallCardLabels = { start: 'Start call notes', show: 'Show call notes', hide: 'Hide call notes' };

interface WarmHandoffTimelineItemProps {
  group: WarmHandoffTimelineGroup;
  highlightRef?: string | null;
  copyDirectLink: (itemReference: string) => Promise<void>;
}

/**
 * The Patient Access warm hand-off card on the timeline. Collapses to **its
 * outcome alone** — anything a coordinator has to act on is a task or a
 * scheduled follow-up, not a line of note text — and only a completed payment
 * gets the check; a sent link does not.
 */
export function WarmHandoffTimelineItem({ group, highlightRef, copyDirectLink }: WarmHandoffTimelineItemProps) {
  const item = group.items[0];
  const { onOpenPaymentOrder } = useTimelineContext();
  const { outcome, paid } = buildWarmHandoffPreview(item.answers);

  return (
    <PatientAccessCallTimelineItem
      title="Warm hand-off"
      reference={getReferenceString(item.reference)!}
      timestamp={item.timestamp}
      sender={item.sender}
      isDraft={item.isDraft}
      worked={hasAnyWarmHandoffAnswer(item.answers)}
      preview={{ outcome, positive: paid }}
      labels={LABELS}
      highlightRef={highlightRef}
      copyDirectLink={copyDirectLink}
      renderCard={(onSaved) => (
        <WarmHandoffCard
          note={item.resource as unknown as Communication}
          answers={item.answers}
          onOpenPaymentOrder={onOpenPaymentOrder}
          readOnly={!item.isDraft}
          onSaved={onSaved}
        />
      )}
    />
  );
}
